import axios from 'axios';

let baseURL = 'http://usedpianos.test/api';

if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://mdwks.com/api';
}

export default axios.create({
    baseURL,
    headers: {
        'gallery-app-id': document.querySelector('[data-gallery-app]').dataset.galleryApp
    }
});



// WEBPACK FOOTER //
// ./src/api.js